/**
 * Facet priority configuration for the SearchFilters sidebar.
 *
 * Priority values determine the render order of facet sections.
 * Lower numbers appear first.
 *
 * Structure: `{ [facetKey]: priorityNumber }`
 */
export const facetConfig = {
  category: 1,
  type: 2,
  tags: 3,
  status: 4,
  published_date: 5,
} as const;

export type FacetKey = keyof typeof facetConfig;

/** Human-readable label for each facet key. */
export const FACET_LABELS: Record<FacetKey, string> = {
  category: 'Category',
  type: 'Type',
  tags: 'Tags',
  status: 'Status',
  published_date: 'Date Range',
};

/** Get facet keys sorted by priority. */
export function getSortedFacetKeys(): FacetKey[] {
  return (Object.keys(facetConfig) as FacetKey[]).sort(
    (a, b) => facetConfig[a] - facetConfig[b]
  );
}
